webpackJsonp([31,123,124,125,280,281],{

/***/ 1104:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            isLoading: false,
            isFullPage: true
        };
    },

    methods: {
        openLoading: function openLoading() {
            var _this = this;

            this.isLoading = true;
            setTimeout(function () {
                _this.isLoading = false;
            }, 10 * 1000);
        }
    }
});

/***/ }),

/***/ 1105:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('b-field', [_c('button', {
    staticClass: "button is-primary is-medium",
    on: {
      "click": _vm.openLoading
    }
  }, [_vm._v("\n                Launch loading\n            ")])]), _vm._v(" "), _c('b-field', [_c('b-switch', {
    model: {
      value: (_vm.isFullPage),
      callback: function($$v) {
        _vm.isFullPage = $$v
      },
      expression: "isFullPage"
    }
  }, [_vm._v("Display loader over full page")])], 1), _vm._v(" "), _c('b-notification', {
    attrs: {
      "closable": false
    }
  }, [_vm._v("\n            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Fusce id fermentum quam. Proin sagittis, nibh id hendrerit imperdiet, elit sapien laoreet elit\n            "), _c('b-loading', {
    attrs: {
      "is-full-page": _vm.isFullPage,
      "active": _vm.isLoading,
      "can-cancel": true
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1106:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            isFullPage: true
        };
    },

    methods: {
        open: function open() {
            var loadingComponent = this.$buefy.loading.open({
                container: this.isFullPage ? null : this.$refs.element.$el
            });
            setTimeout(function () {
                return loadingComponent.close();
            }, 3 * 1000);
        }
    }
});

/***/ }),

/***/ 1107:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('b-field', [_c('button', {
    staticClass: "button is-primary is-medium",
    on: {
      "click": _vm.open
    }
  }, [_vm._v("\n                Launch loading\n            ")])]), _vm._v(" "), _c('b-field', [_c('b-switch', {
    model: {
      value: (_vm.isFullPage),
      callback: function($$v) {
        _vm.isFullPage = $$v
      },
      expression: "isFullPage"
    }
  }, [_vm._v("Display loader over full page")])], 1), _vm._v(" "), _c('b-notification', {
    ref: "element",
    attrs: {
      "closable": false
    }
  }, [_vm._v("\n            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Fusce id fermentum quam. Proin sagittis, nibh id hendrerit imperdiet, elit sapien laoreet elit\n        ")])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1108:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            isLoading: false,
            isFullPage: true
        };
    },

    methods: {
        openLoading: function openLoading() {
            var _this = this;

            this.isLoading = true;
            setTimeout(function () {
                _this.isLoading = false;
            }, 10 * 1000);
        }
    }
});

/***/ }),

/***/ 1109:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('b-field', [_c('button', {
    staticClass: "button is-primary is-medium",
    on: {
      "click": _vm.openLoading
    }
  }, [_vm._v("\n                Launch loading\n            ")])]), _vm._v(" "), _c('b-field', [_c('b-switch', {
    model: {
      value: (_vm.isFullPage),
      callback: function($$v) {
        _vm.isFullPage = $$v
      },
      expression: "isFullPage"
    }
  }, [_vm._v("Display loader over full page")])], 1), _vm._v(" "), _c('b-notification', {
    attrs: {
      "closable": false
    }
  }, [_vm._v("\n            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Fusce id fermentum quam. Proin sagittis, nibh id hendrerit imperdiet, elit sapien laoreet elit\n            "), _c('b-loading', {
    attrs: {
      "is-full-page": _vm.isFullPage,
      "active": _vm.isLoading,
      "can-cancel": true
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }, [_c('b-icon', {
    attrs: {
      "pack": "fas",
      "icon": "sync-alt",
      "size": "is-large",
      "custom-class": "fa-spin"
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1419:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_loading__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__variables_loading__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__examples_ExSimple__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__examples_ExSimple___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__examples_ExSimple__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__raw_loader_examples_ExSimple__ = __webpack_require__(1420);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__raw_loader_examples_ExSimple___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__raw_loader_examples_ExSimple__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__examples_ExProgrammatically__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__examples_ExProgrammatically___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__examples_ExProgrammatically__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__raw_loader_examples_ExProgrammatically__ = __webpack_require__(1421);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__raw_loader_examples_ExProgrammatically___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__raw_loader_examples_ExProgrammatically__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__examples_ExTemplated__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__examples_ExTemplated___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__examples_ExTemplated__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__raw_loader_examples_ExTemplated__ = __webpack_require__(1422);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__raw_loader_examples_ExTemplated___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__raw_loader_examples_ExTemplated__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//













/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            api: __WEBPACK_IMPORTED_MODULE_0__api_loading__["default"],
            variables: __WEBPACK_IMPORTED_MODULE_1__variables_loading__["default"],
            ExSimple: __WEBPACK_IMPORTED_MODULE_2__examples_ExSimple___default.a,
            ExProgrammatically: __WEBPACK_IMPORTED_MODULE_4__examples_ExProgrammatically___default.a,
            ExTemplated: __WEBPACK_IMPORTED_MODULE_6__examples_ExTemplated___default.a,
            ExSimpleCode: __WEBPACK_IMPORTED_MODULE_3__raw_loader_examples_ExSimple___default.a,
            ExProgrammaticallyCode: __WEBPACK_IMPORTED_MODULE_5__raw_loader_examples_ExProgrammatically___default.a,
            ExTemplatedCode: __WEBPACK_IMPORTED_MODULE_7__raw_loader_examples_ExTemplated___default.a
        };
    }
});

/***/ }),

/***/ 1420:
/***/ (function(module, exports) {

module.exports = "<template>\n    <section>\n        <b-field>\n            <button class=\"button is-primary is-medium\" @click=\"openLoading\">\n                Launch loading\n            </button>\n        </b-field>\n        <b-field>\n            <b-switch v-model=\"isFullPage\">Display loader over full page</b-switch>\n        </b-field>\n        <b-notification :closable=\"false\">\n            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Fusce id fermentum quam. Proin sagittis, nibh id hendrerit imperdiet, elit sapien laoreet elit\n            <b-loading :is-full-page=\"isFullPage\" :active.sync=\"isLoading\" :can-cancel=\"true\"></b-loading>\n        </b-notification>\n    </section>\n</template>\n\n<script>\n    export default {\n        data() {\n            return {\n                isLoading: false,\n                isFullPage: true\n            }\n        },\n        methods: {\n            openLoading() {\n                this.isLoading = true\n                setTimeout(() => {\n                    this.isLoading = false\n                }, 10 * 1000)\n            }\n        }\n    }\n</script>\n"

/***/ }),

/***/ 1421:
/***/ (function(module, exports) {

module.exports = "<template>\n    <div>\n        <b-field>\n            <button class=\"button is-primary is-medium\" @click=\"open\">\n                Launch loading\n            </button>\n        </b-field>\n        <b-field>\n            <b-switch v-model=\"isFullPage\">Display loader over full page</b-switch>\n        </b-field>\n        <b-notification ref=\"element\" :closable=\"false\">\n            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Fusce id fermentum quam. Proin sagittis, nibh id hendrerit imperdiet, elit sapien laoreet elit\n        </b-notification>\n    </div>\n</template>\n\n<script>\n    export default {\n        data() {\n            return {\n                isFullPage: true,\n            }\n        },\n        methods: {\n            open() {\n                const loadingComponent = this.$buefy.loading.open({\n                    container: this.isFullPage ? null : this.$refs.element.$el\n                })\n                setTimeout(() => loadingComponent.close(), 3 * 1000)\n            }\n        }\n    }\n</script>\n"

/***/ }),

/***/ 1422:
/***/ (function(module, exports) {

module.exports = "<template>\n    <section>\n        <b-field>\n            <button class=\"button is-primary is-medium\" @click=\"openLoading\">\n                Launch loading\n            </button>\n        </b-field>\n        <b-field>\n            <b-switch v-model=\"isFullPage\">Display loader over full page</b-switch>\n        </b-field>\n        <b-notification :closable=\"false\">\n            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Fusce id fermentum quam. Proin sagittis, nibh id hendrerit imperdiet, elit sapien laoreet elit\n            <b-loading :is-full-page=\"isFullPage\" :active.sync=\"isLoading\" :can-cancel=\"true\">\n                <b-icon\n                    pack=\"fas\"\n                    icon=\"sync-alt\"\n                    size=\"is-large\"\n                    custom-class=\"fa-spin\">\n                </b-icon>\n            </b-loading>\n        </b-notification>\n    </section>\n</template>\n\n<script>\n    export default {\n        data() {\n            return {\n                isLoading: false,\n                isFullPage: true\n            }\n        },\n        methods: {\n            openLoading() {\n                this.isLoading = true\n                setTimeout(() => {\n                    this.isLoading = false\n                }, 10 * 1000)\n            }\n        }\n    }\n</script>\n"

/***/ }),

/***/ 1423:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('Example', {
    attrs: {
      "component": _vm.ExSimple,
      "code": _vm.ExSimpleCode
    }
  }, [_c('p', [_vm._v("The Loading will be closed after about 10 seconds, by pressing escape or by clicking outside.")]), _vm._v(" "), _c('p', [_vm._v("\n                Use "), _c('code', [_vm._v(":is-full-page=\"false\"")]), _vm._v(" to limit loader to its container."), _c('br'), _vm._v("\n                In this case, the container element should be positioned as "), _c('code', [_vm._v("position: relative")]), _vm._v(".\n            ")])]), _vm._v(" "), _c('Example', {
    attrs: {
      "component": _vm.ExProgrammatically,
      "code": _vm.ExProgrammaticallyCode,
      "title": "Programmatically opening"
    }
  }, [_c('p', [_vm._v("When you want to close the Loading, call the "), _c('code', [_vm._v("close()")]), _vm._v(" method from the component.")])]), _vm._v(" "), _c('Example', {
    attrs: {
      "component": _vm.ExTemplated,
      "code": _vm.ExTemplatedCode,
      "title": "Templated"
    }
  }, [_c('div', {
    staticClass: "tags has-addons"
  }, [_c('span', {
    staticClass: "tag is-success"
  }, [_vm._v("New!")]), _vm._v(" "), _c('span', {
    staticClass: "tag is-info"
  }, [_vm._v("0.7.5")])]), _vm._v(" "), _c('p', [_vm._v("Slot is available for loading content.")])]), _vm._v(" "), _c('ApiView', {
    attrs: {
      "data": _vm.api
    }
  }), _vm._v(" "), _c('VariablesView', {
    attrs: {
      "data": _vm.variables
    }
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ 200:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ([{
    props: [{
        name: '<code>active</code>',
        description: 'Whether modal is active or not, use the <code>.sync</code> modifier to make it two-way binding',
        type: 'Boolean',
        values: '—',
        default: '<code>false</code>'
    }, {
        name: '<code>animation</code>',
        description: 'Custom animation (transition name)',
        type: 'String',
        values: '—',
        default: '<code>fade</code>'
    }, {
        name: '<code>is-full-page</code>',
        description: 'Loader will overlay the full page',
        type: 'Boolean',
        values: '—',
        default: '<code>true</code>'
    }, {
        name: '<code>can-cancel</code>',
        description: 'Can close Loading by pressing escape or clicking outside',
        type: 'Boolean',
        values: '—',
        default: '<code>false</code>'
    }, {
        name: '<code>on-cancel</code>',
        description: 'Callback function to call after user canceled (pressed escape / clicked outside)',
        type: 'Function',
        values: '—',
        default: '—'
    }],
    events: [{
        name: '<code>close</code>',
        description: 'Triggers when user closed/canceled or called programmatically from the injected component',
        parameters: '—'
    }]
}]);

/***/ }),

/***/ 201:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ([{
    name: '<code>$loading-background</code>',
    description: 'The loading background color',
    default: '<code>rgba(255,255,255,0.5)</code>'
}, {
    name: '<code>$loading-background-legacy</code>',
    description: 'The loading background color for non-rgba compatible browsers',
    default: '<code>#7f7f7f</code>'
}, {
    name: '<code>$loading-icon-size</code>',
    description: 'The loading icon size',
    default: '<code>3em</code>'
}, {
    name: '<code>$loading-full-page-icon-size</code>',
    description: 'The loading icon size when loader is displayed over full page',
    default: '<code>5em</code>'
}]);

/***/ }),

/***/ 202:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1104),
  /* template */
  __webpack_require__(1105),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 203:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1106),
  /* template */
  __webpack_require__(1107),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 204:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1108),
  /* template */
  __webpack_require__(1109),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 370:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1419),
  /* template */
  __webpack_require__(1423),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ })

});


// WEBPACK FOOTER //
// static/js/31.634e6134adcfe4a11cad.js